/**
 * 评分口径标签的**对客**写法。
 *
 * ★1006 演示机最终回归:报告 Hero 直接把 `score_breakdown.score_version` 原值(「v2.2-evidence」)
 *   印给客户 —— 这是内部口径代号,客户读不懂。当前口径(v2.*)不再出标签;只有旧口径报告
 *   (缺 score_version 或 v1.*)需要提醒「与新报告不可直接比」,换成中文。
 */
export function scoreVersionLabel(version: string | null | undefined): string | null {
  if (!version || /^v1(\.|$)/i.test(version)) return "旧版评分口径";
  return null;
}

/**
 * 剥掉文案里**括号包着的**评分口径代号(「同口径(v2.2-evidence)对比」→「同口径对比」)。
 *
 * ★1006 演示机复测:12 基线对比表注脚是 ai 写进报告数据的 `baseline_compare.note`,原样渲染把
 *   内部代号印给客户。在渲染层剥(不改 ai):已存的报告也一并生效。只认括号里**整段就是代号**的,
 *   不碰别的括号说明。半角/全角括号都认。
 */
const VERSION_IN_PARENS = /\s*[（(]\s*v\d+(?:\.\d+)*(?:-[a-z]+)?\s*[)）]/gi;

export function stripScoreVersionCodes(text: string | null | undefined): string {
  return (text ?? "").replace(VERSION_IN_PARENS, "");
}
